import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import ProfitSharingIndexPage from '../containers/ProfitSharings'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const ProfitSharingsPage = ({
  location,
	match
}) => {
  const dispatch = useDispatch()
	const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
	const { pathname } = location

	useEffect(() => {
		if (current[0] !== 'profit_sharings') {
			dispatch(changeCurrent(['profit_sharings']))
		}
	}, [pathname])

	const path = match.url

  return (
		<Switch>
			<Route path={`${path}/`} component={ProfitSharingIndexPage} exact />
		</Switch>
  )
}

ProfitSharingsPage.propTypes = {
  location: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
}

ProfitSharingsPage.defaultProps = {}

export default ProfitSharingsPage
